import {
  createEdit, DELETE, createSuAs,
} from '@/helpers/enums/table-actions'
import { dateFormatter } from '@/helpers/dateFormatter'
import { UserModel as Model } from './Model'
import { USERS_ROUTES as ROUTES } from './utils'

const getEditRoute = (data) => ({
  name: ROUTES.EDIT,
  params: { id: data.id },
})

export const createTableActions = (profile) => Object.freeze([
  createSuAs(profile),
  createEdit(getEditRoute),
  DELETE,
])

// Для обратной совместимости (если используется где-то без профиля)
export const TABLE_ACTIONS = createTableActions(null)

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Логин',
    value: 'username',
    sortable: false,
    cellClass: 'width-content',
    getRoute: (data) => ({
      name: ROUTES.VIEW,
      params: { id: Model.getId(data) },
    }),
  },
  {
    text: 'Имя',
    value: 'full_name',
    sortable: false,
  },
  {
    text: 'Комментарий',
    value: 'comment',
    sortable: false,
  },
  {
    text: 'Статус',
    value: 'is_active',
    sortable: true,
    width: 116,
    field: (_, data) => Model.getUserStatusLabel(data),
  },
  {
    text: 'Суперюзер',
    value: 'is_superuser',
    sortable: true,
    width: 116,
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: true,
    width: 140,
    field: (value) => value && dateFormatter(value),
  },
])
